module.exports = __webpack_public_path__ + "img/tab2.06418142.png";